import { Store } from 'vuex'
import { RootState } from '../types'
import { client } from '@plugins/feathers'

const mutations: string[] = [
  'addPawn',
  'removePawn',
  'updateTurnID',
  'updateTeamEnzyme',
  'removePlayerMolecule',
  'addPlayerMolecule',
  'increaseTurnID',
  'gameIsWonByTeam',
]

const changeManager = (store: Store<RootState>) => {
  store.subscribe((mutation) => {
    if (mutations.indexOf(mutation.type) !== -1) {
      client.service('api/state').update(1, store.state)
    }
  })

  client.service('api/state').on('updated', (state: any) => {
    store.commit('updateState', state)
  })
}

export default changeManager
